import { useAuth } from '../context/AuthContext';

/**
 * Hook para verificar permisos basados en roles - ACTUALIZADO CON SISTEMA DE REDONDOS
 * Path: backoffice-web/src/hooks/useRoleAccess.js
 * Última modificación: 2025-01-02 07:00
 * Dev: cpalacios01@gmail.com | +595994648273
 */

export const ROLES = {
  ADMINISTRADOR: 1,
  CONDUCTOR: 2,
  RENDIDOR: 3,
};

export const PERMISSIONS = {
  // Rutas permitidas por rol
  routes: {
    [ROLES.ADMINISTRADOR]: [
      '/',
      '/redondos',      // ← NUEVO
      '/itinerarios',   // ← NUEVO
      '/gastos',        // ← NUEVO
      '/choferes',
      '/buses',
      '/usuarios',
      '/tarifas',
      '/cajas',
      '/reportes',
      '/perfil',
    ],
    [ROLES.CONDUCTOR]: [
      '/',
      '/gastos',        // ← NUEVO - Conductores pueden ver gastos
      '/cajas',
      '/perfil',
    ],
    [ROLES.RENDIDOR]: [
      '/',
      '/redondos',      // ← NUEVO - Rendidores gestionan redondos
      '/gastos',        // ← NUEVO - Rendidores pueden ver gastos
      '/cajas',
      '/reportes',
      '/perfil',
    ],
  },
  
  // Menús visibles por rol
  menus: {
    [ROLES.ADMINISTRADOR]: [
      'Dashboard',
      'Redondos',       // ← NUEVO
      'Itinerarios',    // ← NUEVO
      'Gastos',         // ← NUEVO
      'Choferes',
      'Buses',
      'Usuarios',
      'Tarifas',
      'Cajas',
      'Reportes',
    ],
    [ROLES.CONDUCTOR]: [
      'Dashboard',
      'Gastos',         // ← NUEVO
      'Cajas',
    ],
    [ROLES.RENDIDOR]: [
      'Dashboard',
      'Redondos',       // ← NUEVO
      'Gastos',         // ← NUEVO
      'Cajas',
      'Reportes',
    ],
  },
};

export const useRoleAccess = () => {
  const { user } = useAuth();
  
  const hasAccess = (route) => {
    if (!user || !user.role_id) return false;
    const allowedRoutes = PERMISSIONS.routes[user.role_id] || [];
    return allowedRoutes.includes(route);
  };
  
  const canViewMenu = (menuName) => {
    if (!user || !user.role_id) return false;
    const allowedMenus = PERMISSIONS.menus[user.role_id] || [];
    return allowedMenus.includes(menuName);
  };
  
  const isAdmin = () => {
    return user?.role_id === ROLES.ADMINISTRADOR;
  };
  
  const isConductor = () => {
    return user?.role_id === ROLES.CONDUCTOR;
  };
  
  const isRendidor = () => {
    return user?.role_id === ROLES.RENDIDOR;
  };
  
  return {
    hasAccess,
    canViewMenu,
    isAdmin,
    isConductor,
    isRendidor,
    user,
  };
};

export default useRoleAccess;

// cpalacios01@gmail.com | +595994648273
